import { CardDetails } from 'owa-actionable-message-v2';
import { ClientItem } from 'owa-mail-store';
import { mutatorAction } from 'satcheljs/';
import { trace } from 'owa-trace';

const addCardDetailsOnItem = mutatorAction(
    'addCardDetailsOnItem',
    function addCardDetailsOnItem(item: ClientItem, cardDetails: CardDetails[]) {
        if (item.adaptiveCardDetails && item.adaptiveCardDetails.length > 0) {
            trace.info(
                '[ActionableMessageDebug] addCardDetailsOnItem - item already has a card details' +
                    item.adaptiveCardDetails
            );
            return;
        }

        item.adaptiveCardDetails = cardDetails;
    }
);

export default addCardDetailsOnItem;
